import * as React from 'react';
import { Image } from '@cian/ui-kit';

// tslint:disable:max-line-length
export const LayoutsIcon = () => {
  return (
    <Image
      width={'100px'}
      height={'88px'}
      src={'https://cdn.cian.site/media/images/tour_3d_icon@1x.png'}
      sources={[
        {
          srcset:
            'https://cdn.cian.site/media/images/tour_3d_icon@1x.png 1x, ' +
            'https://cdn.cian.site/media/images/tour_3d_icon@2x.png 2x',
        },
      ]}
    />
  );
};

LayoutsIcon.displayName = 'LayoutsIcon';
